const actionTypes = {
    SET_SPONSOR_PRODUCTS: 'SET_SPONSOR_PRODUCTS',
    RESET_SPONSOR_PRODUCTS: 'RESET_SPONSOR_PRODUCTS'
};

module.exports = actionTypes;
